module.exports = __webpack_public_path__ + "media/react/components/PatientBox/RentalStatus/assets/icon_empty-8cc1d4ebf06506a101ab964f237b1c6c.svg";